import { http } from '@/core/helpers/axiosHelper';
import { LocationQuery } from 'vue-router';
import { Employee } from '../../employees/employee.interface';

export class EmployeeService {
   async getEmployees(companyId: number, query?: LocationQuery) {
      const response = await http.get<Array<Employee>>(`/customers/${companyId}/employees`, { params: { ...query } });
      return response.data;
   }

   async getEmployee() {
      throw Error('Method not implemented');
   }

   async postEmployee() {
      throw Error('Method not implemented');
   }

   async putEmployee() {
      throw Error('Method not implemented');
   }

   async deleteEmployee() {
      throw Error('Method not implemented');
   }
}
